module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/day01_04_stay-a306d002f73db891d6fbd969c0f3dc59.jpg";